import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Globals } from '../../globals';
import { EnergySupplier } from '../../interfaces';

@Injectable({
  providedIn: 'root',
})
export class EnergySuppliersService {
  private readonly client = inject(HttpClient);
  private readonly globals = inject(Globals);

  getAll(): Observable<EnergySupplier[]> {
    const url = `${this.globals.apiRoot}/JwtEnergySupplier`;
    return this.client.get<EnergySupplier[]>(url);
  }
}
